import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Sun, Moon } from "lucide-react";
import Blason from "./Blason";
import Wordmark from "./Wordmark";
import { T } from "./content";
import { scrollToId, scrollTop } from "./hooks";

const SECTIONS = ["maison", "univers", "club", "galerie", "fondateur", "contact"];

export default function Header({ lang, toggleLang, theme, toggleTheme }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const t = T[lang];
  const navigate = useNavigate();
  const location = useLocation();
  const onHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
  }, [open]);

  const go = (id) => {
    setOpen(false);
    if (onHome) scrollToId(id);
    else navigate(`/#${id}`);
  };

  const goHome = () => {
    setOpen(false);
    if (onHome) scrollTop();
    else navigate("/");
  };

  return (
    <>
      <header className={`header ${scrolled ? "scrolled" : ""}`} data-testid="site-header">
        <a
          className="brand"
          href="#top"
          data-testid="brand-home"
          onClick={(e) => {
            e.preventDefault();
            goHome();
          }}
        >
          <Blason className="brand__crest" />
          <span className="brand__mark">
            <Wordmark className="brand__wm" />
            <span className="brand__sub">LUXEMBOURG</span>
          </span>
        </a>

        <div className="container header__row">
          <nav className="nav-links" aria-label="Primary">
            {SECTIONS.map((s) => (
              <a
                key={s}
                className="nav-link"
                href={`#${s}`}
                data-testid={`nav-${s}`}
                onClick={(e) => {
                  e.preventDefault();
                  go(s);
                }}
              >
                {t.nav[s]}
              </a>
            ))}
          </nav>

          <div className="controls">
            <div className="pill" data-testid="lang-toggle">
              <button
                className={lang === "fr" ? "active" : ""}
                onClick={() => lang !== "fr" && toggleLang()}
                data-testid="lang-fr"
              >
                FR
              </button>
              <button
                className={lang === "en" ? "active" : ""}
                onClick={() => lang !== "en" && toggleLang()}
                data-testid="lang-en"
              >
                EN
              </button>
            </div>
            <button
              className="icon-btn"
              onClick={toggleTheme}
              aria-label="Toggle theme"
              data-testid="theme-toggle"
            >
              {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
            </button>
            <button
              className={`burger ${open ? "open" : ""}`}
              onClick={() => setOpen((o) => !o)}
              aria-label="Menu"
              aria-expanded={open}
              data-testid="burger"
            >
              <span />
              <span />
            </button>
          </div>
        </div>
      </header>

      <div className={`menu ${open ? "open" : ""}`} data-testid="fullscreen-menu">
        <div className="container">
          <ul className="menu__list">
            {SECTIONS.map((s, i) => (
              <li key={s}>
                <a
                  href={`#${s}`}
                  onClick={(e) => {
                    e.preventDefault();
                    go(s);
                  }}
                  data-testid={`menu-${s}`}
                >
                  <span className="idx">0{i + 1}</span>
                  {t.nav[s]}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
